import { useContext } from "react";
import { ModulesContext } from "../context/Modules/ModulesContext";

const useModules = () => {
  const context = useContext(ModulesContext);
  
  if (!context) {
    throw new Error("useModules must be used within ModulesProvider");
  }
  
  return context;
};

export default useModules;
